export enum ListsTableType {
  Assets = 'assets',
  Selection = 'selection',
  Documents = 'documents',
  Related = 'related'
}
